import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';

import { type RootState } from 'store';

export type SelectedPeriodType = 1 | 7 | 30 | 60;

export type SelectedPeriodState = {
  selectedPeriod: SelectedPeriodType;
};

const INITIAL_STATE: SelectedPeriodState = {
  selectedPeriod: 60,
};

const selectedPeriodFilterSlice = createSlice({
  name: 'selectedPeriodFilter',
  initialState: INITIAL_STATE,
  reducers: {
    updateSelectedPeriod(state, action: PayloadAction<SelectedPeriodType>) {
      state.selectedPeriod = action.payload;
    },
  },
});

export const getSelectedPeriod = (state: RootState) =>
  state.selectedPeriodFilter.selectedPeriod;

export const { updateSelectedPeriod } = selectedPeriodFilterSlice.actions;

export default selectedPeriodFilterSlice.reducer;

export const useGetSelectedPeriodFilter = () =>
  useSelector((state: RootState) => state.selectedPeriodFilter.selectedPeriod);

export const useUpdateSelectedPeriodFilter = () => {
  const dispatch = useDispatch();

  const handleUpdateSelectedPeriod = (
    newSelectedPeriod: SelectedPeriodType,
  ) => {
    dispatch(updateSelectedPeriod(newSelectedPeriod));
  };

  return {
    handleUpdateSelectedPeriod,
  };
};
